import { create } from 'zustand';

interface IPGContext {
    iframeURL: string;
    setIframeURL: (url: string) => void;
}

export const useIPGContext = create<IPGContext>(set => {
    return {
        iframeURL: '',
        setIframeURL: (url): void => {
            set({ iframeURL: url });
        },
    };
});
